import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ConfirmationDetail from './confirmation-detail';
import Loader from '../shared/loader';

class PaymentRedsysForm extends Component {
    constructor(props) {
        super(props);
        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        this.form = React.createRef();
        this.state = {
            ds_MerchantParameters: '',
            ds_Signature: '',
            backToPrev: false,
        };

        this.backToPrevStep = this.backToPrevStep.bind(this);
    }

    componentDidMount() {
        this.props.getRedsysInfo().then((result) => {
            this.setState({
                ds_MerchantParameters: this.props.order.redsysPaymentInfo.Ds_MerchantParameters,
                ds_Signature: this.props.order.redsysPaymentInfo.Ds_Signature,
            });
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    backToPrevStep() {
        window.scrollTo(0, 0);

        this.setState((prevState) => ({
            ...prevState,
            backToPrev: true,
        }));

        this.props.handlePaymentBackStep(this.props.order, this.props.locale)
            .catch(() => {
                this.setState((prevState) => ({
                    ...prevState,
                    backToPrev: false,
                }));
            });
    }

    render() {
        const { order, stores } = this.props;

        return (
            <div>
                {this.state.backToPrev && this.props.displayLoader && (
                    <div className="checkout-loading-container">
                        <FormattedMessage id="please-wait" defaultMessage="please wait" />
                        <Loader displayLoader size={36} />
                    </div>
                )}
                <div style={{ display: this.state.backToPrev && this.props.displayLoader ? 'none' : 'inherit' }}>
                    {order.redsysPaymentError && (
                        <div className="alert alert-danger" role="alert" style={{ margin: 25 }}>
                            <FormattedMessage id="redsys-error" default="An error has occurred in your payment" />
                        </div>
                    )}

                    <ConfirmationDetail order={order} stores={stores} />
                    <form
                        name="from"
                        action={this.props.order.redsysPaymentInfo ? this.props.order.redsysPaymentInfo.Redsys_url : process.env.REACT_APP_REDSYS_URL}
                        method="POST"
                        ref={this.form}
                    >
                        <input type="hidden" name="Ds_SignatureVersion" value="HMAC_SHA256_V1" />
                        {/* eslint-disable-next-line max-len */}
                        <input type="hidden" name="Ds_MerchantParameters" value={this.state.ds_MerchantParameters} />
                        <input type="hidden" name="Ds_Signature" value={this.state.ds_Signature} />
                        <div className="checkout-payment-button-block">
                            <button
                                onClick={this.backToPrevStep}
                                type="button"
                                className="button--outlined"
                                style={{ margin: 30 }}
                            >
                                <FormattedMessage id="back" defaultMessage="Back" />
                            </button>
                            <button
                                type="submit"
                                className="button--outlined"
                                disabled={!this.props.order.redsysPaymentInfo || !this.props.order.redsysPaymentInfo.Ds_MerchantParameters}
                                onClick={() => this.props.addRedsysPaymentError(false)}
                            >
                                <FormattedMessage id="savePayment" defaultMessage="Save Payment Details" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default injectIntl(PaymentRedsysForm);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment-redsys-form.jsx
 **/